import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import {ModalLayout} from '@appbase/templates'
import TotalSystem from './TotalSystem.vue'

@Component({
  components: { ModalLayout,TotalSystem },
})
export default class TotalSystemModal extends Vue {
  @Prop({type: String, default:''}) menuName!:string
  @Prop({type: String, default:'SYSTEM'}) title!:string

  handleClose() {
    this.closeCurrentModal()
  }
}
